﻿var $ = require('jquery');

var StickyHeader = function (customOptions) {
    var defaultOptions = {
        element: null,
        actionDelay: 300
    };
    var options = $.extend({}, defaultOptions, customOptions);

    if (options.element === null) {
        throw new Error('element must be specified');
    }

    var $header = $(options.element);
    var $headerChildren = $header.children();


    // enforce css required for the header to function like a sticky header

    var distanceTravelledInSameDirection = 0;
    var lastScrollTop = 0;
    var scrollDifference = 0;
    var directionChange = 'no';

    var updateSameScrollDistance = function (windowScrollTop) {
        let scrollTop = typeof windowScrollTop === 'undefined' ? $(window).scrollTop() : windowScrollTop;

        scrollDifference = scrollTop - lastScrollTop;

        lastScrollTop = scrollTop;

		if (distanceTravelledInSameDirection > 0 && scrollDifference < 0) {
			distanceTravelledInSameDirection = 0;
			directionChange = 'up';
		} else if (distanceTravelledInSameDirection < 0 && scrollDifference > 0) {//could be OR, whatever!
			distanceTravelledInSameDirection = 0;
			directionChange = 'down';
		} else {
			directionChange = 'no';
		}
		distanceTravelledInSameDirection += scrollDifference;
	};

	var scrollTimeout = null;
	var scrollJustStarted = true;
	var onScrollTimeout = function () {
		scrollJustStarted = true;
		onStoppedScrolling();
	};

    var onWindowScroll = function () {

        if ($(window).scrollTop() >= 0) {
            updateSameScrollDistance();//has side effects!
        } else {
            updateSameScrollDistance(0);//has side effects!
        }

        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(onScrollTimeout, options.actionDelay);

		if (scrollJustStarted) {
			scrollJustStarted = false;
			onScrollStart();
		} else {
			onScrolling();
		}
		if (directionChange == 'down') {
			onFirstScrollDown();
		} else if (directionChange == 'up') {
			onFirstScrollUp();
		}
	};

    var onFirstScrollDown = function () {
        $header.css('position', 'absolute');
        $header.css('top', $header.offset().top + 'px');
    };

    var onFirstScrollUp = function () {

        if ($header.offset().top + $header.height() < $(window).scrollTop()) {//assuming position is set to absolute    
            $header.css('position', 'absolute');
            $header.css('top', $(window).scrollTop() - $header.height() + 'px');
        }

    };

    var onStoppedScrolling = function () {
        $header.css('top', $header.offset().top + 'px');
        $header.css('position', 'absolute');

        let offset = 0;
        $headerChildren.each((index, element) => {
            let elementHeight = $(element).height();
            if ($header.offset().top + offset + elementHeight / 2 < $(window).scrollTop()) {
                offset += elementHeight;
            } else {
                return false;
            }
        });
        if (!$header.hasClass('attached')) {
            $header.animate({
                top: $(window).scrollTop() - offset
            });
        }
    };

    var onScrolling = function () {//executed after first scroll down and first scroll up, on next scroll after scroll start

		if (scrollDifference < 0) {
			if ($header.offset().top > $(window).scrollTop()) {
				$header.css('position', 'fixed');
				$header.css('top', 0);
			}
		}
	};
	var onScrollStart = function () {
		$header.stop();
    };
    if(!$("#hsi-body").length){
        $(window).on('scroll', onWindowScroll);
    }
};

module.exports = StickyHeader;